import { render } from "./Keuangan.vue?vue&type=template&id=192ed020"
import script from "./Keuangan.vue?vue&type=script&lang=js"
export * from "./Keuangan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__